// Remembers where the user was on a list page, so coming back from a tune
// lands on the same card with the same filters.
const read = (key) => {
  try {
    return JSON.parse(sessionStorage.getItem(key) || "null");
  } catch {
    return null;
  }
};

export const readView = read;

export const saveView = (key, state = {}) => {
  sessionStorage.setItem(key, JSON.stringify({ ...state, y: window.scrollY }));
};

export const saveScroll = (key) => {
  const prev = read(key) || {};
  sessionStorage.setItem(key, JSON.stringify({ ...prev, y: window.scrollY }));
};

// notation renders in a few frames — nudge the scroll a few times, then stop
export const restoreScroll = (y) => {
  if (!y) return () => {};
  const timers = [0, 120, 350, 700].map((t) => setTimeout(() => window.scrollTo(0, y), t));
  return () => timers.forEach(clearTimeout);
};
